import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "sales-document-image-preview" */'./SalesDocumentImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('sales-document-image-preview')),
  LoadingComponent: () => null
});